import http from "@/http-common";
import filehttp from "@/http-file-common";

class ConnectRetailDataService {
    getCountryAndStation(): Promise<any> {
        return http.api.post('/getCountryAndStation/');
    }

    getRetailDataInfo(data: any): Promise<any> {
        return http.api.post("/getRetailDataInfo/", data);
    }

    checkAndUploadRetailDataFile(data: FormData): Promise<any> {
        return http.api.post('/checkAndUploadRetailDataFile/', data);
    }

    downloadRetailDataInfo(data: any): Promise<any> {
        return filehttp.api.post("/downloadRetailDataInfo/", data);
    }

}

export default new ConnectRetailDataService();